/* eslint-env browser */
/*
 * Adds optional, terrible functionality for button toolbars.
 *
 * https://getbootstrap.com/docs/3.4/javascript/#buttons
 */
require('../bootstrap/js/button');
